// @flow

import React, { PureComponent } from 'react';
import type { Element } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from 'components/TextArea.scss';

/**
 * TextArea React component.
 */
class TextArea extends PureComponent<*, *> {
  /**
   *  Props implementation.
   */
  static propTypes = {
    extendStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    placeholder: PropTypes.string,
    value: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func
  };

  static defaultProps: Object = {
    value: ''
  };

  /**
   * Render
   * @return {ReactElement} markup
   */
  render(): Element<*> {
    const {
      extendStyle,
      value,
      onChange,
      onBlur,
      name,
      placeholder,
      required
    } = this.props;
    const { classTextArea } = styles;

    return (
      <textarea
        className={classNames(classTextArea, extendStyle)}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        name={name}
        placeholder={placeholder}
        required={required}
      />
    );
  }
}

export default TextArea;



// WEBPACK FOOTER //
// ./src/Common/TextArea/index.js